import {
	FilledInputProps as MuiFilledInputProps,
	InputProps as MuiInputProps,
	OutlinedInputProps as MuiOutlinedInputProps,
	TextField as MuiTextField,
} from "@material-ui/core";
import React, { MutableRefObject } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import { useFieldControl } from "./FieldHelper";

export default function TextField<T extends FieldValues>(props: {
	label: string;
	name: string;
	control: Control<T>;
	inputRef?: MutableRefObject<HTMLInputElement | undefined>;
	disabled?: boolean;
	multiline?: boolean;
	autoFocus?: boolean;
	type?: string;
	InputProps?:
		| Partial<MuiInputProps>
		| Partial<MuiFilledInputProps>
		| Partial<MuiOutlinedInputProps>;
}) {
	const { error, value } = useFieldControl<string>(props.control, props.name);

	return (
		<Controller
			as={MuiTextField}
			type={props.type}
			inputRef={props.inputRef}
			control={props.control}
			name={props.name}
			value={value}
			disabled={props.disabled}
			multiline={props.multiline}
			rowsMax={props.multiline ? 4 : undefined}
			error={!!error}
			helperText={error?.message}
			variant="outlined"
			label={props.label}
			autoFocus={props.autoFocus}
			InputProps={props.InputProps}
			fullWidth
		/>
	);
}
